// extracted by mini-css-extract-plugin
export default {"root":"Rewards_root__AyvyE","leftColumn":"Rewards_leftColumn__pTrth","rightColumn":"Rewards_rightColumn__-aRWA"};